import { render, staticRenderFns } from "./gBottomBtn.vue?vue&type=template&id=6e42720b&scoped=true&"
import script from "./gBottomBtn.vue?vue&type=script&lang=js&"
export * from "./gBottomBtn.vue?vue&type=script&lang=js&"
import style0 from "./gBottomBtn.vue?vue&type=style&index=0&id=6e42720b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e42720b",
  null
  
)

export default component.exports